import useAsyncData from "../../../../hooks/use-async-data";
import mileageService from "../../mileage.service";
import MileageDictionaryList from "./mileage-dictionary-list";
import MileageDictionaryListParams from "./mileage-dictionary-list-params";

const useMileageDictionaryList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<MileageDictionaryList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    loadParams: MileageDictionaryListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const mileageDictionaryList = await mileageService.getDictionaryList(
        loadParams,
        signal,
      );

      setData(mileageDictionaryList);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useMileageDictionaryList;
